import React from 'react'
import PropTypes from 'prop-types'

import { Filters } from 'components'

const AssetInventoryFilter = ({ filter, assetInventoryCategories = [] }) => {
  const filteredAssetInventoryCategories = assetInventoryCategories?.map(
    (category) => ({
      id: category.id,
      name: category.name,
    }),
  )

  return (
    <Filters filter={filter} alphabeticalOrder>
      <input textfieldinput="true" label="Identificador" name="id" />
      <input textfieldinput="true" label="Nome" name="name" />
      <select
        multipleselectinput="true"
        label="Categoria"
        name="assetInventoryCategoryId"
        optionvalues={filteredAssetInventoryCategories}
      />
    </Filters>
  )
}

AssetInventoryFilter.propTypes = {
  filter: PropTypes.object.isRequired,
  assetInventoryCategories: PropTypes.array,
}

export default AssetInventoryFilter
